import "./dashboardCard.css"

export function DashboardCard({ about, text, value }) {
    return (
        <div className="dashboard-card d-flex flex-column">
            <div className={`${about}-icon icon`}></div>
            <div className="card-name">{text}</div>
            <div className="card-value">${value}</div>
        </div>
    )
}